import React, { useState } from "react";

export function InitialOfferExplanationTabs({
  counterpart,
  termCopy,
  yourExplanation,
  partnerExplanation,
}) {
  const [selectedExplanation, setSelectedExplanation] = useState("partner");
  const explanationTabs = [
    {
      id: "partner",
      label: `${counterpart.capitalizedTerm} Explanation`,
      text: partnerExplanation,
    },
    {
      id: "yours",
      label: "Your Explanation",
      text: yourExplanation,
    },
  ];
  const activeExplanation =
    explanationTabs.find((tab) => tab.id === selectedExplanation) ||
    explanationTabs[0];

  return (
    <section className="rounded-md border border-gray-200 bg-white p-5 space-y-4">
      <h3 className="text-3xl font-semibold text-gray-900">
        Initial {termCopy.capitalizedTerm} Explanations
      </h3>
      <div
        className="inline-flex rounded-md border border-gray-200 bg-gray-50 p-1"
        role="tablist"
        aria-label={`Initial ${termCopy.term} explanations`}
      >
        {explanationTabs.map((tab) => {
          const selected = tab.id === activeExplanation.id;

          return (
            <button
              key={tab.id}
              id={`initial-offer-${tab.id}-explanation-tab`}
              type="button"
              role="tab"
              aria-selected={selected}
              aria-controls="initial-offer-explanation-panel"
              className={`rounded px-4 py-2 text-xl font-semibold transition ${
                selected
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
              }`}
              onClick={() => setSelectedExplanation(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      <div
        id="initial-offer-explanation-panel"
        role="tabpanel"
        aria-labelledby={`initial-offer-${activeExplanation.id}-explanation-tab`}
        className="rounded-xl bg-gray-50 p-4 text-xl text-gray-700 whitespace-pre-wrap break-words"
      >
        {activeExplanation.text || "No explanation provided."}
      </div>
    </section>
  );
}
